export default __webpack_public_path__ + "static/media/SBIR.6a49caec.jpg";